import CliplisterVideo from "./cliplister-video";
import ArtikelVideo from "./artikel-video";

const CLASSNAME_VIDEO_PLAYER = "content-video__video-player";
const CLASS_VIDEO_PLAYER = `.${CLASSNAME_VIDEO_PLAYER}`;

const PROVIDER_CLIPLISTER = "cliplister";
const PROVIDER_ARTIKEL = "cover";

class ContentVideo extends HTMLElement {
  constructor() {
    super();
    this.videoProviderMap = {};
  }

  connectedCallback() {
    this.setElements();
    this.initVideoPlayers();
  }

  setElements() {
    this.videoPlayerElements = this.querySelectorAll(CLASS_VIDEO_PLAYER);
  }

  initVideoPlayers() {
    this.videoPlayerElements.forEach(videoPlayerElement => {
      if (this.isOfType(videoPlayerElement, PROVIDER_CLIPLISTER)) {
        let cliplisterVideo = this.videoProviderMap[PROVIDER_CLIPLISTER];
        if (!cliplisterVideo) {
          cliplisterVideo = new CliplisterVideo();
          this.videoProviderMap[PROVIDER_CLIPLISTER] = cliplisterVideo;
        }
        cliplisterVideo.initForNode(videoPlayerElement);
      } else if (this.isOfType(videoPlayerElement, PROVIDER_ARTIKEL)) {
        let artikelVideo = this.videoProviderMap[PROVIDER_ARTIKEL];
        if (!artikelVideo) {
          artikelVideo = new ArtikelVideo();
          this.videoProviderMap[PROVIDER_ARTIKEL] = artikelVideo;
        }
        artikelVideo.initForNode(videoPlayerElement);
      } else {
        window.console.log("content-video: Not yet supported video provider")
      }
    })
  }

  isOfType(videoPlayerElement, token) {
    return videoPlayerElement.classList.contains(`${CLASSNAME_VIDEO_PLAYER}--${token}`);
  }
}

if (!customElements.get("content-video")) {
  customElements.define("content-video", ContentVideo);
}
